import React from 'react';

import useTestTypeFeatures from 'src/shared/hooks/useTestTypeFeatures';

import styles from './SingleTimepointMetricsOverview.module.scss';
import IucnMetrics from '../metrics/iucn-metrics/IucnMetrics';
import BacterialFunctionalDiversityMetrics from '../metrics/bacterial-functional-diversity/BacterialFunctionalDiversityMetrics';
import EvolutionaryMetrics from '../metrics/evolutionary-metrics/EvolutionaryMetrics';
import SpeciesRichnessMetrics from '../metrics/species-richness-metrics/SpeciesRichnessMetrics';
import CommunityComparisonMetric from '../metrics/community-comparison-metric/CommunityComparisonMetric';
import FungalFunctionalDiversityMetrics from '../metrics/fungal-functional-diversity/FungalFunctionalDiversityMetrics';
import FungalToBacterialRatioMetrics from '../metrics/fungal-to-bacterial-ratio/FungalToBacterialRatioMetrics';

import ChegdMetric from '../metrics/chegd-metrics/ChegdMetric';
import InvasiveMetrics from '../metrics/invasive-metrics/InvasiveMatrics';
import MarineSedimentPollutionIndexMetrics from '../metrics/marine-sediment-pollution-index-metrics/MarineSedimentPollutionIndexMetrics';
import TotalSpeciesMetrics from '../metrics/total-species-metrics/TotalSpeciesMetrics';

const SingleTimepointMetricsOverview = () => {
    const {
        hasSpeciesRichnessFeature,
        hasEvolutionaryDiversityFeature,
        hasIucnRedListFeature,
        hasCommunityComparisonFeature,
        hasBfdFeature,
        hasFfdFeature,
        hasChegdFeature,
        hasInvasivesFeature,
        hasFbRatioFeature,
        hasMspiFeature,
        hasTotalSpeciesFeature,
    } = useTestTypeFeatures();

    return (
        <div className={styles.singleTimepointMetricsOverview} data-testid='single-timepoint-metrics-overview'>
            {hasTotalSpeciesFeature && <TotalSpeciesMetrics />}
            {hasSpeciesRichnessFeature && <SpeciesRichnessMetrics />}
            {hasEvolutionaryDiversityFeature && <EvolutionaryMetrics />}
            {hasIucnRedListFeature && <IucnMetrics />}
            {!hasChegdFeature && hasInvasivesFeature && <InvasiveMetrics />}
            {hasBfdFeature && <BacterialFunctionalDiversityMetrics />}
            {hasFfdFeature && <FungalFunctionalDiversityMetrics />}
            {hasFbRatioFeature && <FungalToBacterialRatioMetrics />}
            {hasChegdFeature && <ChegdMetric />}
            {hasCommunityComparisonFeature && <CommunityComparisonMetric />}
            {hasMspiFeature && <MarineSedimentPollutionIndexMetrics />}
        </div>
    );
};

export default SingleTimepointMetricsOverview;
